import { render, staticRenderFns } from "./CardFullWidth.vue?vue&type=template&id=41f27f73&scoped=true&"
import script from "./CardFullWidth.vue?vue&type=script&lang=js&"
export * from "./CardFullWidth.vue?vue&type=script&lang=js&"
import style0 from "./CardFullWidth.vue?vue&type=style&index=0&id=41f27f73&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f27f73",
  null
  
)

component.options.__file = "CardFullWidth.vue"
export default component.exports